const ENV_PATH = '/adminApi/api/v1/ui/envs';
const CAPTCHA_PATH = '/adminAuth/auth/v1/captcha';
const LOGO_PATH = '/adminApi/api/v1/ui/logo';
const GET_TEST_ALL_RESULT = '/selfCheck/get/health_check';

// 获取配置的环境变量，如：登陆时是否开启图形验证码
function getEnv() {
  return this.$reqGet(ENV_PATH).then(rsp => rsp.data.result);
}

// 获取登陆验证码
function getCaptcha() {
  return this.$reqGet(CAPTCHA_PATH).then(rsp => rsp.data);
}

// 获取自定义图标信息
function getIconURL(iconType, enterprise) {
  return `${LOGO_PATH}?type=${iconType}${enterprise ? `&enterprise=${enterprise}` : ''}`;
}

// 获取自定义图标信息
function getIcon(iconType, enterprise) {
  return this.$reqGet(getIconURL(iconType, enterprise)).then(rsp => rsp.data);
}

// 上传自定义图标
function uploadIcon(iconType, enterprise, file) {
  const data = new FormData();
  data.append('file', file);
  data.append('type', iconType);
  data.append('enterprise', enterprise);

  return this.$reqPut(LOGO_PATH, data);
}

// 删除自定义图标
function deleteIcon(iconType, enterprise) {
  return this.$reqDelete(getIconURL(iconType, enterprise));
}

// 获取服务测试状态
function getAllServiceStatus() {
  return this.$reqGet(GET_TEST_ALL_RESULT).then(res => res.data);
}

export default {
  getEnv,
  getCaptcha,
  getIconURL,
  getIcon,
  uploadIcon,
  deleteIcon,
  getAllServiceStatus,
};



// WEBPACK FOOTER //
// ./src/api/system.js